<template>
    <v-dialog v-model="showDialog" max-width="600px" persistent>
        <v-sheet class="dialog" rounded>
            <div class="dialog-header">{{ $t("users.edit_user") }}</div>
            <div class="dialog-content">
                <v-form ref="form_edit_user">
                    <v-row>
                        <v-col cols="12" md="6">
                            <v-text-field
                                :label="$t('users.name')"
                                :value="user.lastname"
                                dense
                                disabled
                                hide-details="auto"
                                light
                                outlined
                                readonly
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field
                                :label="$t('users.firstname')"
                                :value="user.firstname"
                                dense
                                disabled
                                hide-details="auto"
                                light
                                outlined
                                readonly
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field
                                :label="$t('users.email')"
                                :value="user.email"
                                dense
                                disabled
                                hide-details="auto"
                                light
                                outlined
                                readonly
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-select
                                v-model="role"
                                :items="visibleRoles()"
                                :label="$t('users.role')"
                                dense
                                hide-details="auto"
                                light
                                outlined
                            >
                                <template #item="{ item }">
                                    {{ $t(`role.${item}`) }}
                                </template>
                                <template #selection="{ item }">
                                    {{ $t(`role.${item}`) }}
                                </template>
                            </v-select>
                        </v-col>
                    </v-row>
                </v-form>
            </div>
            <div class="dialog-footer d-flex">
                <v-btn elevation="0" @click="showDialog = false">
                    {{ $t("global.cancel") }}
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn :loading="loading" color="primary" elevation="0"
                       @click="saveUser">
                    {{ $t("global.validate") }}
                </v-btn
                >
            </div>
        </v-sheet>
    </v-dialog>
</template>

<script>
import roles from "../../../mixins/roles";

export default {
    name: "EditUser",
    mixins: [roles],
    props: {
        visible: {
            type: Boolean,
            required: true,
            default: false,
        },
        user: {
            type: Object,
            require: true,
            default: () => {
                return {
                    firstname: null,
                    lastname: null,
                    email: null,
                    role: null
                }
            }
        },
    },
    data() {
        return {
            role: null,
            loading: false
        };
    },
    computed: {
        showDialog: {
            get() {
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.$emit("close");
                }
            },
        },
    },
    mounted() {
        this.role = this.user.role
    },
    methods: {
        async saveUser() {
            try {
                this.loading = true
                await this.$api.users.update(this.user.id, {
                    role: this.role
                })
                this.$emit('close')
                this.loading = false
            } catch (e) {
                this.loading = false
            }

        }
    }
};
</script>
